export const PICTONYM_ANDROID_CLAIM_XP = 20;

export const buildPictonymXpClaimHistoryId = (claimType, cycleId) => {
  const safeType = String(claimType || '').trim().toLowerCase();
  const safeCycleId = String(cycleId || '').trim();
  if (!['entry', 'vote'].includes(safeType) || !safeCycleId) return '';
  return `pictonym:${safeType}:${safeCycleId}`;
};
